export const GET_DEFAULT_CARRIERS_SUCCESS = 'GET_DEFAULT_CARRIERS_SUCCESS';
export const GET_DEFAULT_CARRIERS_REQUEST = 'GET_DEFAULT_CARRIERS_REQUEST';
export const GET_DEFAULT_CARRIERS_FAILURE = 'GET_DEFAULT_CARRIERS_FAILURE';
export const GET_DEFAULT_CARRIERS_REST = 'GET_DEFAULT_CARRIERS_REST';
export const getDefaultCarriersSuccess = (payload) => ({
    type: GET_DEFAULT_CARRIERS_SUCCESS,
    payload,
});
export const getDefaultCarriersRequest = () => ({
    type: GET_DEFAULT_CARRIERS_REQUEST,
});
export const getDefaultCarriersFailure = (payload) => ({
    type: GET_DEFAULT_CARRIERS_FAILURE,
    payload,
});
export const getDefaultCarriersRest = () => ({
    type: GET_DEFAULT_CARRIERS_REST,
});
